<template>
  <Header />
  <div class="w-full font-basic mt-28">
    <!-- PC 상단  -->
    <div
      class="lg:w-[1280px] lg:h-[468px] lg:flex lg:justify-between lg:mx-auto lg:items-center lg_tall:w-[1200px] lg_tall:h-[468px] lg_tall:flex lg_tall:justify-between lg_tall:mx-auto lg_tall:items-center sm:hidden">
      <div class="lg:flex lg:flex-col lg:ml-[80px] lg_tall:flex lg_tall:flex-col lg_tall:ml-[60px] justify-center">
        <img class="w-[222px] h-[48px]" src="@/assets/qmeet_logo.png" alt="qmeet-logo">
        <div
          class="lg:mt-5 lg:font-bold lg:text-[44px] lg:text-text-0 lg:leading-[52px] lg:tracking-[-0.0045em] lg_tall:mt-5 lg_tall:font-bold lg_tall:text-[44px] lg_tall:text-text-0 lg_tall:leading-[52px] lg_tall:tracking-[-0.0045em]">
          <p>국내 최초 QA 아웃소싱&</p>
          <p>솔루션 매칭 플랫폼, 큐밋</p>
        </div>
        <div
          class="lg:mt-2 lg:text-content-size text-gray lg:leading-[26px] lg:tracking-[-0.0045em] lg_tall:mt-2 lg_tall:text-content-size lg_tall:leading-[26px] lg_tall:tracking-[-0.0045em]">
          <p>고객사 프로젝트를 내일처럼 해주는 아웃소싱사와</p>
          <p>최적의 솔루션을 가장 스마트하게 찾는 방법</p>
        </div>
        <a href="https://www.q-meet.com" target="_blank" rel="noopener noreferrer"
          class="w-[200px] rounded-full items-center justify-center bg-main-0 py-4 cursor-pointer mt-4 block text-center">
          <p class="font-medium text-white">홈페이지 바로가기 →</p>
        </a>

      </div>
      <!-- 영상 -->
      <div
        class="lg:w-[640px] lg:h-[360px] lg_tall:w-[640px] lg_tall:h-[360px] rounded-lg border-8 border-gray_3 overflow-hidden">
        <iframe class="-z-10" width="640" height="360" src="https://www.youtube.com/embed/Lby21IZf4mU" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture fullscreen"
          allowfullscreen></iframe>
      </div>
    </div>

    <!--모바일 상단-->
    <div class="flex flex-col px-5 mx-auto lg:hidden lg_tall:hidden justify-center">
      <img class="sm:w-[222px]" src="@/assets/qmeet_logo.png" alt="">
      <div class="sm:mt-5 sm:leading-[32px] sm:tracking-[-0.0045em] text-text-0 font-bold sm:text-medium-size-2">
        <p>국내 최초 QA 아웃소싱&</p>
        <p>솔루션 매칭 플랫폼, 큐밋</p>
      </div>
      <div class="sm:mt-2 sm:leading-[24px] sm:tracking-[-0.0045em] text-gray font-medium">
        <p>고객사 프로젝트를 내일처럼 해주는 아웃소싱사와</p>
        <p>최적의 솔루션을 가장 스마트하게 찾는 방법</p>
      </div>
      <div class="px-8 py-4">

      </div>
      <a href="https://www.q-meet.com" target="_blank" rel="noopener noreferrer"
        class="w-[180px] h-[44px] rounded-full flex items-center justify-center bg-main-0 cursor-pointer mt-4 text-center">
        <p class="font-medium text-white text-small-size-1">홈페이지 바로가기 →</p>
      </a>
      <!-- Tailwind 3.2 이상 + aspect-ratio 유틸리티 사용 -->
      <!-- aspect-ratio 활용 (Tailwind 3.2+) -->
      <div class="sm:w-[320px] sm:h-[180px] rounded-lg border-8 border-gray_3 overflow-hidden mt-10">
        <iframe class="-z-10 sm:w-[320px] sm:h-[180px]" src="https://www.youtube.com/embed/Lby21IZf4mU" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
      </div>
    </div>

    <!-- PC 아카이빙 플랫폼  -->
    <div
      class="lg:w-[1280px] lg:h-[668px] lg:mx-auto lg:flex lg:flex-col lg:items-center lg:py-10 lg_tall:w-[1200px] lg_tall:h-[668px] lg_tall:mx-auto lg_tall:flex lg_tall:flex-col lg_tall:items-center lg_tall:py-10 sm:hidden">
      <img class="lg:mt-[60px] lg_tall:mt-[60px]" src="@/assets/qmeet_archive.png" alt="">
      <div
        class="lg:flex lg:flex-col lg:items-center lg:text-medium-size-2 lg:tracking-[-0.0045em] lg:leading-[36px] lg:mt-[60px] lg_tall:flex lg_tall:flex-col lg_tall:items-center lg_tall:text-medium-size-2 lg_tall:tracking-[-0.0045em] lg_tall:leading-[36px] lg_tall:mt-[60px] text-text-1">
        <p class="font-semibold">고객사는 플랫폼 이용료 무료!</p>
        <p>프로젝트 등록하면 24시간 이내 아웃소싱사가 무료 견적으로 지원</p>
        <p>큐밋에서는 공고 등록, 비교 견적, 계약, 프로젝트 수행관리까지 쉽고, 간편하게 관리합니다.</p>
      </div>
    </div>

    <!-- 모바일 아카이빙 플랫폼  -->
    <div class="sm:flex sm:flex-col sm:px-5 :mx-auto sm:py-5 lg:hidden lg_tall:hidden sm:justify-center">
      <img class="mt-7" src="@/assets/qmeet_archive.png" alt="">
      <p class="text-text-1 text-[13px] text-center mt-7 leading-[18px] tracking-[-0.0045em]"><span
          class="font-semibold">고객사는 플랫폼 이용료 무료!</span>
        <br>
        프로젝트 등록하면 24시간 이내 아웃소싱사가 무료 견적으로
        <br>
        지원 큐밋에서는 공고 등록, 비교 견적, 계약, 프로젝트 수행관리까지 쉽고 간편하게 관리합니다.
      </p>
    </div>

    <!-- PC 고객의 소리  -->
    <div
      class="lg:w-full lg:h-[700px] lg:mx-auto lg:flex lg:flex-col lg:items-center lg:pt-10 lg_tall:w-full lg_tall:h-[700px] lg_tall:mx-auto lg_tall:flex lg_tall:flex-col lg_tall:items-center lg_tall:pt-10 lg:bg-gray_2 sm:hidden">
      <p class="font-bold text-text-0 lg:text-medium-size-0 lg_tall:text-medium-size-0">고객의 소리</p>

      <div
        class="customer-review lg:flex lg:w-[1200px] lg:gap-x-[30px] lg:gap-y-10 lg:mt-[60px] lg_tall:flex lg_tall:w-[1200px] lg_tall:gap-x-[30px] lg_tall:gap-y-10 lg_tall:mt-[60px]">

        <!-- 이커머스 **사 장보리님 -->
        <div
          class="lg:flex lg:w-[546px] lg:h-[104px] lg:justify-start lg:py-4 lg_tall:flex lg_tall:w-[546px] lg_tall:h-[104px] lg_tall:justify-start lg_tall:py-4 bg-white rounded-xl lg:pl-4 lg:gap-6 lg_tall:pl-4 lg_tall:gap-6">
          <img class="lg:w-[78px] lg:h-[78px] lg_tall:w-[78px] lg_tall:h-[78px]" src="@/assets/ic_avarar_007.png"
            alt="">
          <div class="lg:flex lg:flex-col gap-[10px] lg_tall:flex lg_tall:flex-col ">
            <p class="text-main-1">이커머스 **사</p>
            <p class="text-gray_1 lg:text-content-size lg_tall:text-content-size">우리회사는 테스트 운영 예산이 적은데 가능할까요?</p>
          </div>
        </div>

        <!-- 이커머스 **사 장보리님 답변 -->
        <div
          class="lg:flex lg:w-[624px] lg:justify-between lg:pl-8 lg:pr-6 lg:h-[104px] lg_tall:flex lg_tall:w-[624px] lg_tall:justify-between lg_tall:pl-8 lg_tall:pr-6 lg_tall:h-[104px]  border border-main-0 rounded-xl bg-[#F3FAF9]">
          <div class="lg:flex lg:flex-col lg:mt-4 lg_tall:flex lg_tall:flex-col lg_tall:mt-4">
            <p class="text-main-1">큐밋 매니저</p>
            <p class="text-gray_1 lg:text-content-size lg:mt-[10px] lg_tall:text-content-size lg_tall:mt-[10px]">아웃소싱을
              통한 유연한 장·단기 프로젝트가 운영 가능합니다.</p>
          </div>
          <img class="lg:w-[78px] lg:h-[78px] lg:mt-3 lg_tall:w-[78px] lg_tall:h-[78px] lg_tall:mt-3"
            src="@/assets/ic_avarar_008.png" alt="">
        </div>

      </div>

      <div
        class="customer-review lg:flex lg:w-[1200px] lg:gap-x-[30px] lg:gap-y-10 lg:mt-10 lg_tall:flex lg_tall:w-[1200px] lg_tall:gap-x-[30px] lg_tall:gap-y-10 lg_tall:mt-10">

        <!-- 금융 **사 박머니님 -->
        <div
          class="lg:flex lg:w-[526px] lg:h-[104px] lg:justify-start lg:py-4 lg:pl-4 lg:gap-6
                    lg_tall:flex lg_tall:w-[526px] lg_tall:h-[104px] lg_tall:justify-start lg_tall:py-4 lg_tall:pl-4 lg_tall:gap-6 bg-white rounded-xl">
          <img class="lg:w-[78px] lg:h-[78px] lg_tall:w-[78px] lg_tall:h-[78px]" src="@/assets/ic_avarar_009.png"
            alt="">
          <div class="lg:flex lg:flex-col gap-[10px] lg_tall:flex lg_tall:flex-col">
            <p class="text-main-1">금융 **사</p>
            <p class="text-gray_1 lg:text-content-size lg_tall:text-content-size">큐밋에서 검증된 QA 파트너와 협업 가능한가요?</p>
          </div>
        </div>

        <!-- 금융 **사 박머니님 답변 -->
        <div class="lg:flex lg:w-[644px] lg:justify-between lg:pl-8 lg:pr-6 lg:h-[104px]
                 lg_tall:flex lg_tall:w-[644px] lg_tall:justify-between lg_tall:pl-8 lg_tall:pr-6 lg_tall:h-[104px]
                 border border-main-0 rounded-xl bg-[#F3FAF9]">
          <div class="lg:flex lg:flex-col lg:mt-4 lg_tall:flex lg_tall:flex-col lg_tall:mt-4">
            <p class="text-main-1">큐밋 매니저</p>
            <p class="text-gray_1 lg:text-content-size lg:mt-[10px] lg_tall:text-content-size lg_tall:mt-[10px]">검증된 QA
              파트너스를 통한 서비스 질을 향상 시킬 수 있어요!</p>
          </div>
          <img class="lg:w-[78px] lg:h-[78px] lg:mt-3 lg_tall:w-[78px] lg_tall:h-[78px] lg_tall:mt-3"
            src="@/assets/ic_avarar_010.png" alt="">
        </div>

      </div>

      <div
        class="customer-review lg:flex lg:w-[1200px] lg:gap-x-[30px] lg:gap-y-10 lg:mt-10 lg_tall:flex lg_tall:w-[1200px] lg_tall:gap-x-[30px] lg_tall:gap-y-10 lg_tall:mt-10">

        <!-- 자동차 **사 김운전님  -->
        <div class="lg:flex lg:w-[482px] lg:h-[122px] lg:justify-start lg:py-4 lg:pl-4 lg:gap-6
                    lg_tall:flex lg_tall:w-[482px] lg_tall:h-[122px] lg_tall:justify-start lg_tall:py-4 lg_tall:pl-4 lg_tall:gap-6
                  bg-white rounded-xl">
          <img class="lg:w-[78px] lg:h-[78px] lg_tall:w-[78px] lg_tall:h-[78px]" src="@/assets/ic_avarar_011.png"
            alt="">
          <div class="lg:flex lg:flex-col gap-[10px] lg_tall:flex lg_tall:flex-col">
            <p class="text-main-1">자동차 **사</p>
            <p class="text-gray_1 text-content-size">당장 프로젝트를 시작하고 싶은데<br>큐밋에는 지금 당장 투입 될 인재가 있나요?</p>
          </div>
        </div>

        <!-- 자동차 **사 김운전님 답변 -->
        <div class="lg:flex lg:w-[688px] lg:justify-between lg:pl-8 lg:pr-6 lg:h-[122px]
                 lg_tall:flex lg_tall:w-[688px] lg_tall:justify-between lg_tall:pl-8 lg_tall:pr-6 lg_tall:h-[122px]
                border border-main-0 rounded-xl bg-[#F3FAF9]">
          <div class="lg:flex lg:flex-col lg:mt-4 lg_tall:flex lg_tall:flex-col lg_tall:mt-4">
            <p class="text-main-1">큐밋 매니저</p>
            <p class="text-gray_1 lg:text-content-size lg:mt-[10px] lg_tall:text-content-size lg_tall:mt-[10px]">투입이 필요한
              프로젝트에 적합한 엔지니어 선정과 선발 시간 단축<br>이 가능합니다.</p>
          </div>
          <img class="lg:w-[78px] lg:h-[78px] lg:mt-3 lg_tall:w-[78px] lg_tall:h-[78px] lg_tall:mt-3"
            src="@/assets/ic_avarar_008.png" alt="">
        </div>
      </div>

      <div class="customer-review">
        <a href="https://www.q-meet.com/customer-case?pageNo=1&tab=10" target="_blank" rel="noopener noreferrer"
          class="rounded-full items-center justify-center bg-main-0 px-10 py-4 cursor-pointer mt-10 block text-center">
          <p class="font-medium text-white">큐밋 고객 성공사례 보기 →</p>
        </a>
      </div>

    </div>

    <!-- 모바일 고객의 소리 -->
    <div
      class="sm:flex sm:flex-col sm:px-5 sm:pb-10 sm:mx-auto sm:py-10 lg:hidden lg_tall:hidden sm:justify-center bg-gray_2">
      <p class="font-bold text-center text-medium-size-2 text-text-0 mb-7">고객의 소리</p>
      <div class="flex flex-col gap-3 customer-review">
        <!-- 대형 온라인 서점 -->
        <CustomerVoice_M_1 :avaratUrl="require('@/assets/ic_avatar_001.png')" name="이커머스 **사"
          description="우리회사는 테스트 운영 예산이<br>적은데 가능할까요?"
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]" />

        <!-- 큐밋매니저 -->
        <CustomerVoice_M_2 :avaratUrl="require('@/assets/ic_avatar_002.png')" name="큐밋 매니저"
          description="아웃소싱을 통한 유연한 장·단기<br>프로젝트가 운영 가능합니다."
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]"
          rootStyle="sm:flex sm:gap-4 sm:py-4 sm:pl-3 sm:pr-4 rounded-2xl border-main-0 border bg-[#F3FAF9]" />

        <!-- 금융 **사 -->
        <CustomerVoice_M_1 :avaratUrl="require('@/assets/ic_avatar_003.png')" name="금융 **사"
          description="큐밋에서 검증된  QA 파트너와 협업 가능한가요?"
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]" />

        <!-- 큐밋매니저 -->
        <CustomerVoice_M_2 :avaratUrl="require('@/assets/ic_avatar_004.png')" name="큐밋 매니저"
          description="검증된 QA 파트너스를 통한 서비스 질을 향상 시킬 수 있어요!"
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]"
          rootStyle="sm:flex sm:gap-4 sm:py-4 sm:pl-3 sm:pr-4 rounded-2xl border-main-0 border bg-[#F3FAF9]" />

        <!-- 자동차 **사 김운전님  -->
        <CustomerVoice_M_1 :avaratUrl="require('@/assets/ic_avatar_005.png')" name="자동차 **사"
          description="당장 프로젝트를 시작하고 싶은데<br>큐밋에는 지금 당장 투입 될 인재가 있나요?"
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]" />

        <!-- 큐밋매니저 -->
        <CustomerVoice_M_2 :avaratUrl="require('@/assets/ic_avatar_004.png')" name="큐밋 매니저"
          description="투입이 필요한 프로젝트에 적합한<br>엔지니어 선정과 선발 시간 단축이 가능합니다."
          descriptionStype="font-medium text-small-size text-gray_1 leading-[145%]"
          rootStyle="sm:flex sm:gap-4 sm:py-4 sm:pl-3 sm:pr-4 rounded-2xl border-main-0 border bg-[#F3FAF9]" />
      </div>

      <div class="customer-review mx-auto">
        <a href="https://www.q-meet.com/customer-case?pageNo=1&tab=10" target="_blank" rel="noopener noreferrer"
          class="px-6 h-[44px] rounded-full flex items-center justify-center bg-main-0 cursor-pointer mt-4 text-center">
          <p class="font-medium text-white text-small-size-1">큐밋 고객 성공사례 보기 →</p>
        </a>
      </div>
    </div>

    <!-- PC B2B QA 아웃소싱, 왜 큐밋인가요? -->
    <div
      class="lg:w-[1280px] lg:mx-auto lg:flex lg:flex-col gap-10 lg:items-center lg:py-10 lg_tall:w-[1200px] lg_tall:mx-auto lg_tall:flex lg_tall:flex-col lg_tall:items-center lg_tall:pt-10 sm:hidden">
      <p class="font-bold text-text-0 lg:text-medium-size-0 lg_tall:text-medium-size-0">B2B QA 아웃소싱, 왜 큐밋인가요?</p>

      <img src="@/assets/ic_why_qmeet.png" alt="">

      <div
        class="lg:flex lg:flex-col lg:items-center lg:text-medium-size-2 lg:tracking-[-0.0045em] lg:leading-[36px] lg_tall:flex lg_tall:flex-col lg_tall:items-center lg_tall:text-medium-size-2 lg_tall:tracking-[-0.0045em] lg_tall:leading-[36px] text-text-1">
        <p>IT 분야의 B2B 고객들은</p>
        <p>전문 테스팅 아웃소싱과 QA 솔루션을 위해 큐밋을 방문하고 있습니다.</p>
      </div>

      <a href="https://www.q-meet.com/customer-case/82" target="_blank" rel="noopener noreferrer"
        class="rounded-full items-center justify-center bg-main-0 px-10 py-4 cursor-pointer block text-center">
        <p class="font-medium text-white">큐밋 VS IT 아웃소싱 플랫폼 비교 →</p>
      </a>

    </div>

    <!-- 모바일 B2B QA 아웃소싱, 왜 큐밋인가요? -->
    <div class="sm:flex sm:flex-col sm:px-5 sm:pb-10 sm:mx-auto sm:py-10 lg:hidden lg_tall:hidden sm:justify-center">
      <p class="font-bold text-center text-medium-size-2 text-text-0 mb-7">B2B QA 아웃소싱<br>왜 큐밋인가요?</p>

      <img src="@/assets/ic_why_qmeet.png" alt="">

      <p class="text-text-1 text-[13px] text-center mt-7 leading-[18px] tracking-[-0.0045em]">
        IT 분야의 B2B 고객들은
        <br>
        전문 테스팅 아웃소싱과 QA 솔루션을 위해
        <br>
        큐밋을 방문하고 있습니다.
      </p>

      <div class="mx-auto">
        <a href="https://www.q-meet.com/customer-case/82" target="_blank" rel="noopener noreferrer"
          class="px-6 h-[44px] rounded-full flex items-center justify-center bg-main-0 cursor-pointer mt-4 text-center">
          <p class="font-medium text-white text-small-size-1">큐밋 VS IT 아웃소싱 플랫폼 비교 →</p>
        </a>
      </div>
      
    </div>

    <!-- PC 큐밋 서비스 소개  -->
    <div
      class="lg:w-[1280px] lg_tall:w-full lg_tall:pl-[10px]    pb-20 mx-auto flex flex-col items-center pt-10 sm:hidden">
      <p class="font-bold text-text-0 text-medium-size-0">큐밋 서비스 소개</p>

      <div class="lg:w-[1280px] lg_tall:w-full flex flex-col gap-24 mt-[60px]">

        <!--패스트 매칭 서비스-->
        <div class="flex gap-10 justify-start">
          <img class="w-640[px] h-[400px]" src="@/assets/qmeet_service_001.png" alt="">
          <div class="flex flex-col justify-end">
            <p class="text-main-0">고객이 원하는 QA 서비스를 무료로!</p>
            <p class="text-text-0 font-semibold text-medium-size-1">프로젝트 등록하면 무료 견적, 무료 엔지니어 매칭</p>
            <ul class="mt-5 text-text-1 leading-[26px] tracking-[-0.0045em]">
              <li>등록부터 아웃소싱 계약까지 플랫폼 이용료는 0원</li>
              <li>공고 등록 후 24시간 이내 파트너사 지원 발생, 2~4주 내 엔지니어 배치 완료</li>
              <li>장/단기 프로젝트 상관없이, 단독/컨소시움 파트너스 매칭이 가능</li>
            </ul>
            <a href="https://www.q-meet.com/project-regi" target="_blank" rel="noopener noreferrer"
              class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[180px] h-[44px] mt-4 bg-white">
              <p class="font-medium text-main-0 text-small-size">무료 비교견적 받기 →</p>
            </a>
          </div>
        </div>

        <!-- 올인원 관리 서비스-->
        <div class="flex gap-10 justify-between">
          <div class="flex flex-col justify-end">
            <p class="text-main-0">매칭 - 계약 - 관리 - 대급지급까지 한번에</p>
            <p class="text-text-0 font-semibold text-medium-size-1">올인원 관리 서비스</p>
            <ul class="mt-5 text-text-1 leading-[26px] tracking-[-0.0045em]">
              <li>수행/지원 내역통해 지원현황, 인터뷰 요청, 합격 등 쉬운 커뮤니케이션 기능 제공</li>
              <li>고객사가 쉽고 편한 프로젝트 수행 및 돌발사항 관리 가능</li>
              <li>큐밋에서 결과 리포트 검수 후 → 대급지급 → 파트너스에 대금 전달 완료</li>
            </ul>
            <a href="https://www.q-meet.com/project-list?pageNo=1" target="_blank" rel="noopener noreferrer"
              class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[180px] h-[44px] mt-4 bg-white">
              <p class="font-medium text-main-0 text-small-size">프로젝트 보러가기 →</p>
            </a>
          </div>
          <img class="640[px] h-[400px]" src="@/assets/qmeet_service_002.png" alt="">
        </div>

        <!-- 토탈 매니징 서비스 서비스-->
        <div class="flex gap-10 justify-start">
          <img class="lg-640[px] lg-h-[400px]" src="@/assets/qmeet_service_003.png" alt="">
          <div class="flex flex-col justify-end">
            <p class="text-main-0">20년 업력 노하우 담은 고객사 맞춤형 관리</p>
            <p class="text-text-0 font-semibold text-medium-size-1">토탈 매니징 서비스</p>
            <ul class="mt-5 text-text-1 leading-[26px] tracking-[-0.0045em]">
              <li>QA 직무 경력 20년 이상의 큐밋 매니저를 배정하여 엔지니어 검증/매칭 시작</li>
              <li>엔지니어 채용도 큐밋 매니저가 해결 ( 단독/ 컨소시엄 모두 지원)</li>
              <li>인원선발이 끝이 아닙니다. 프로젝트 수행 및 종료까지 지원</li>
            </ul>
          </div>
        </div>

        <!-- QA 툴 스토어-->
        <div class="flex gap-10 lg:justify-between">
          <div class="flex flex-col justify-end">
            <p class="text-main-0">테스트 솔루션과 툴의 모든 아카이빙</p>
            <p class="text-text-0 font-semibold text-medium-size-1">QA 툴 스토어</p>
            <ul class="mt-5 text-text-1 leading-[26px] tracking-[-0.0045em]">
              <li>테스트 관련 솔루션 및 툴을 큐밋에서 한 번에 보여주는 솔루션 스토어 오픈</li>
              <li>서비스와 맞는 솔루션을 2개 이상 비교 제안해드리고, 할인가 구매 가능</li>
              <li>해당 솔루션(자동화, 보안 등)을 교육받은 엔지니어 매칭하여 업무 효율화 증대</li>
            </ul>
            <a href="https://www.q-meet.com/solution?pageNo=1" target="_blank" rel="noopener noreferrer"
              class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[180px] h-[44px] mt-4 bg-white">
              <p class="font-medium text-main-0 text-small-size">스토어 보러가기 →</p>
            </a>
          </div>
          <img class="640[px] h-[400px]" src="@/assets/qmeet_service_004.png" alt="">
        </div>
      </div>

    </div>

    <!-- 모바일 큐밋 서비스 소개  -->
    <div class="sm:flex sm:flex-col sm:px-5 sm:pb-10 sm:mx-auto sm:py-10 lg:hidden  lg_tall:hidden sm:justify-center">
      <p class="font-bold text-center text-medium-size-2 text-text-0 mb-7">큐밋 서비스 소개</p>
      <div class="flex flex-col gap-[60px]">
        <!-- 패스트 매칭 서비스-->
        <div class="flex flex-col">
          <img src="@/assets/qmeet_service_001.png" alt="">
          <p class="text-small-size-1 text-main-0 lg:tracking-[-0.0045em] leading-[18px] mt-7">고객이 원하는 QA 서비스를 무료로!
          </p>
          <p class="font-semibold text-text-0 text-content-size mt-1">프로젝트 등록하면 무료 견적, 무료 엔지니어 매칭</p>
          <ul class="mt-4 text-small-size-1 leading-[18px] text-text-1 tracking-[-0.0045em]">
            <li>등록부터 아웃소싱 계약까지 플랫폼 이용료는 0원</li>
            <li>공고 등록 후 24시간 이내 파트너사 지원 발생, 2~4주 내 엔지니어 배치 완료</li>
            <li>장/단기 프로젝트 상관없이, 단독/컨소시움 파트너스 매칭이 가능</li>
          </ul>          
        </div>
        <!-- 올인원 관리 서비스-->
        <div class="flex flex-col">
          <img src="@/assets/qmeet_service_002.png" alt="">
          <p class="text-small-size-1 text-main-0 lg:tracking-[-0.0045em] leading-[18px] mt-7">매칭 - 계약 - 관리 - 대급지급까지 한번에
          </p>
          <p class="font-semibold text-text-0 text-content-size mt-1">올인원 관리 서비스</p>
          <ul class="mt-4 text-small-size-1 leading-[18px] text-text-1 tracking-[-0.0045em]">
            <li>수행/지원 내역통해 지원현황, 인터뷰 요청, 합격 등<br>쉬운 커뮤니케이션 기능 제공</li>
            <li>고객사가 쉽고 편한 프로젝트 수행 및 돌발사항 관리<br>가능</li>
            <li>큐밋에서 결과 리포트 검수 후 → 대급지급 → 파트너스에 대금 전달 완료</li>
          </ul>
          <a href="https://www.q-meet.com/project-list?pageNo=1" target="_blank" rel="noopener noreferrer"
            class="rounded-full border-main-0 border-[1px] flex items-center justify-center px-6 h-[44px] mt-4 bg-white mx-auto">
            <p class="font-medium text-main-0 text-small-size-1">프로젝트 보러가기 →</p>
          </a>
        </div>
        <!-- 토탈 매니징 서비스-->
        <div class="flex flex-col">
          <img src="@/assets/qmeet_service_003.png" alt="">
          <p class="text-small-size-1 text-main-0 lg:tracking-[-0.0045em] leading-[18px] mt-7">20년 업력 노하우 담은 고객사 맞춤형 관리
          </p>
          <p class="font-semibold text-text-0 text-content-size mt-1">토탈 매니징 서비스</p>
          <ul class="mt-4 text-small-size-1 leading-[18px] text-text-1 tracking-[-0.0045em]">
            <li>QA 직무 경력 20년 이상의 큐밋 매니저를 배정하여<br>엔지니어 검증/매칭 시작</li>
            <li>엔지니어 채용도 큐밋 매니저가 해결 ( 단독/ 컨소시엄 모두 지원)</li>
            <li>인원선발이 끝이 아닙니다. 프로젝트 수행 및 종료까지 지원</li>
          </ul>
        </div>
        <!-- QA 툴 스토어-->
        <div class="flex flex-col">
          <img src="@/assets/qmeet_service_004.png" alt="">
          <p class="text-small-size-1 text-main-0 lg:tracking-[-0.0045em] leading-[18px] mt-7">테스트 솔루션과 툴의 모든 아카이빙</p>
          <p class="font-semibold text-text-0 text-content-size mt-1">QA 툴 스토어</p>
          <ul class="mt-4 text-small-size-1 leading-[18px] text-text-1 tracking-[-0.0045em]">
            <li>테스트 관련 솔루션 및 툴을 큐밋에서 한 번에 보여주는 솔루션 스토어 오픈</li>
            <li>서비스와 맞는 솔루션을 2개 이상 비교 제안해드리고, 할인가 구매 가능</li>
            <li>해당 솔루션(자동화, 보안 등)을 교육받은 엔지니어 매칭하여 업무 효율화 증대</li>
          </ul>
          <a href="https://www.q-meet.com/solution?pageNo=1" target="_blank" rel="noopener noreferrer"
            class="rounded-full border-main-0 border-[1px] flex items-center justify-center px-6 h-[44px] mt-4 bg-white mx-auto">
            <p class="font-medium text-main-0 text-small-size-1">스토어 보러가기 →</p>
          </a>
        </div>
      </div>
    </div>

    <!-- PC 큐밋 프로세스  -->
    <div class="w-full mx-auto flex flex-col py-10 items-center bg-[#F3FAF9] sm:hidden">
      <p class="font-bold text-medium-size-0 text-text-0 lg:tracking-[-0.0045em]">큐밋 프로세스</p>
      <p class="text-text-1 text-medium-size-1 tracking-[-0.0045em] mt-5">가입하고 5분안에 프로젝트 등록까지 완료!</p>

      <img class="" src="@/assets/qmeet_process.png" alt="qmeet-logo">


      <Button
        class="rounded-full border-main-0 border-[1px] flex items-center justify-center w-[156px] h-[44px] mt-8 bg-white"
        @click="goToRegProj">
        <p class="font-medium text-main-0 text-small-size">무료 프로젝트 등록</p>
      </Button>

    </div>

    <!-- 모바일 큐밋 프로세스  -->
    <div
      class="sm:flex sm:flex-col sm:px-5 sm:mx-auto sm:py-10 lg:hidden lg_tall:hidden sm:justify-center bg-[#F3FAF9]">
      <p class="font-bold text-center text-medium-size-2 text-text-0 mb-5">큐밋 프로세스</p>
      <p class="text-text-1 tracking-[-0.0045em] text-center">가입하고 5분안에 프로젝트 등록까지 완료!</p>
      <div style="overflow: hidden; display: block;">
        <img src="@/assets/ic_qmeet_mobile_process.png" alt="큐밋 프로세스"
          style="display: block; width: 100%; max-width: 100%; margin-top: 16px; transform: translateX(0);">
      </div>      
    </div>

    <!-- 문의  -->
    <Qna_1 id="contact-us" propPlatform="3" title="큐밋에" description="전담 매니저가 맞춤 아웃소싱사를 매칭해 드립니다." />
    <Footer />

  </div>
</template>
<script>
import Header from '@/components/layoutComponents/Header.vue'
import Footer from '@/components/layoutComponents/Footer.vue'
import CustomerVoice from '@/components/baseComponents/CustomerVoice.vue'
import CustomerVoice_1 from '@/components/baseComponents/CustomerVoice_1.vue'
import Qna_1 from '@/components/baseComponents/Qna_1.vue'
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomerVoice_M_1 from '@/components/baseComponents/CustomerVoice_M_1.vue'
import CustomerVoice_M_2 from '@/components/baseComponents/CustomerVoice_M_2.vue'
export default {
  components: {
    Header, Footer, CustomerVoice, CustomerVoice_1, Qna_1, CustomerVoice_M_1, CustomerVoice_M_2
  },
  data() {
    return {
    }
  },
  methods: {
    goToRegProj() {
      // 현재 탭에서 이동
      window.open('https://www.q-meet.com/project-regi', '_blank');
    },
    goToUrl() {
      // 특정 URL로 이동
      window.open('https://www.q-meet.com', '_blank');
    },
    scrollToTarget(targetId) {
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      // 원하는 만큼 윗쪽으로 더 스크롤하기 위해 offset 설정 (예: 100px)
      const offset = 100;
      // getBoundingClientRect().top + 현재 스크롤 위치 - offset
      const yPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: yPosition,
        behavior: 'smooth'
      });
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);

    // 각 customer-review 내부의 자식 div를 개별적으로 처리
    gsap.utils.toArray('.customer-review').forEach((container) => {
      const children = container.children; // customer-review의 자식 요소들
      gsap.fromTo(
        children,
        {
          opacity: 0,
          y: 50, // 아래에서 위로 올라오는 초기 상태
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.5, // 질문과 답변 간 시간차
          scrollTrigger: {
            trigger: container,
            start: 'top 80%', // 뷰포트의 80% 지점에서 트리거
            toggleActions: 'play none none none', // 트리거 동작
          },
        }
      );
    });
  },

}
</script>
<style scoped>
.customer-review>div {
  opacity: 0;
  /* 초기 상태 */
  transform: translateY(50px);
  /* 아래에서 시작 */
}

ul {
  list-style-type: disc;
  /* 기본 불릿 스타일 */
  padding-left: 20px;
  /* 불릿이 보이도록 패딩 추가 */
}

li {
  margin-bottom: 10px;
  /* 리스트 항목 간격 */

}
</style>